import { cn } from '@/utils/tailwind';

export const LayoutReviewsContent = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-[16px] rounded-[16px] border border-gr-200 bg-white p-[20px]',
        'grid grid-cols-1 gap-x-[20px] md:grid-cols-2',
        // isAnswered && 'opacity-80',
        // isUnanswerable && 'bg-gr-50',
        className,
      )}
    >
      {children}
    </div>
  );
};
